'use client';

import { useEffect } from 'react';

export default function SourcePointScripts() {
  useEffect(() => {
    const loadScript = (src: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        // Add timeout to prevent infinite loading
        const timeout = setTimeout(() => {
          reject(new Error(`Script load timed out for ${src}`));
        }, 10000); // 10 second timeout

        script.onload = () => {
          clearTimeout(timeout);
          resolve();
        };

        script.onerror = () => {
          clearTimeout(timeout);
          reject(new Error(`Script failed to load: ${src}`));
        };

        // Load in head for faster initialization
        document.head.appendChild(script);
      });
    };

    const loadScripts = async () => {
      try {
        // Load sourcepoint.js first
        await loadScript('/sourcepoint.js');

        // Then load sourcepoint-utils.js
        await loadScript(
          'https://cdn.signupgenius.com/vendor/latest/sourcepoint/utility.js'
        );
      } catch {
        // Optionally retry loading after a delay
        setTimeout(loadScripts, 2000);
      }
    };

    loadScripts();

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[src*="sourcepoint"]');
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return null;
}
